<template>
  <div class="full">
    <div class="yoqb-layer yoqb-close" @click="$emit('yoqb', false)"></div>
    <div class="content-box" ref="bordercolor" :class="{ [currentLevel]: true, isRed: isRed }">
      <div class="question-row">
        <img v-if="currentLevel == 'easy'" src="../img/question-easy.svg" alt="Question">
        <img v-if="currentLevel == 'medium'" src="../img/question-medium.svg" alt="Question">
        <img v-if="currentLevel == 'hard'" src="../img/question-hard.svg" alt="Question">
      </div>
      <!-- <PhoneBox> -->
        <div class="marginer">
          <!-- <h1>Level: {{ currentLevel }}</h1> -->
          <ContentDisplay @answered="onAnswered" class="full" v-if="question" mode="mark" :question="question" @saveTo="(v) => { saveTo = v }" @view="(v) => { view = v }" @submit="onSubmit"></ContentDisplay>
        </div>
      <!-- </PhoneBox> -->

      <div class="question-row" v-if="ansIs === 'correct'">
        <button class="maibutton yes" v-if="showClose" @click="$emit('yoqb', false)">
          Correct, Close
        </button>
      </div>
      <div class="question-row" v-if="ansIs === 'incorrect'">
        <button class="close-btn" v-if="showClose" @click="$emit('yoqb', false)">
          Incorrect, Close
        </button>
      </div>
    </div>
    <div v-if="view === 'myscript'" class="overlay">
      <MyScript @done="(v) => { myScriptDone({ value: v.latex }) }" @view="(v) => { view = v; }" />
    </div>
  </div>
</template>

<script>
import * as QS from '../yoqb-compos/question.js'
import * as Question from '@/api/question.js'
import * as Analytics from '@/api/analytics.js'
import * as Folder from '@/api/folders.js'
// import * as Question from '@/api/question.js'
import * as Sound from '@/audio.js'
import * as sAPI from '../api/strapi.js'

export default {
  components: {
    ContentDisplay: require('../yoqb-compos/ContentDisplay.vue').default,
    MyScript: require('../yoqb-compos/MyScript.vue').default,
    // PhoneBox: require('../yoqb-compos/PhoneBox.vue').default,
  },
  data () {
    return {
      ansIs: '',
      showClose: false,
      view: 'main',
      saveTo: false,
      QS,
      questionObj: false,
      questionID: false,
      question: false,
      mark: false,
      fullObject: false,
      currentLevel: false,
      loggers: '-----',
      actionType: ''
    }
  },
  props: {
    yoqb: {},
    isRed: {
      default: false
    },
    // currentLevel: {},
    // questionID: {
    //   required: true
    // }
  },
  mounted () {
    this.onMountedGo()
    // require('../compos/MyScript.vue').default.preload()
  },
  computed: {

    // questionID () {
    //   return this.$route.params.questionID
    // }
  },
  watch: {
    // question: {
    //   deep: true,
    //   handler (v) {
    //     // setTimeout(() => {
    //     if (v.result) {
    //       if (v.result.mark > 0) {
    //         this.$emit('right')
    //       } else {
    //         this.$emit('wrong')
    //       }
    //       console.log(v.result.mark)
    //       this.$forceUpdate()
    //       this.$parent.$forceUpdate()
    //     }
    //     // }, 1000)
    //   }
    // }
  },
  methods: {
    getCurrentLevel () {
      let cell = this.yoqb.cell
      let myself = this.yoqb.myself
      let game = this.yoqb.game
      let players = this.yoqb.players

      let { level } = sAPI.getDifficultyAndMode({ game, myself, cell, players })
      return level
      // if (cell.uid === 'map') {
      //   return 'easy'
      // } else if (cell.core) {
      //   return 'hard'
      // } else if (cell.lvl >= 2) {
      //   return 'hard'
      // } else if (cell.lvl >= 1) {
      //   return 'hard'
      // } else if (cell.lvl >= 0) {
      //   return 'medium'
      // }
    },
    myScriptDone ({ value }) {
      if (!this.saveTo) { return }

      if (this.saveTo.operation === 'set') {
        this.saveTo.obj[this.saveTo.key] = `$$${(value + '').trim()}$$`
      } else {
        this.saveTo.obj[this.saveTo.key] += `$$${value}$$\n`
      }
    },
    async loadQuestion () {
      let resp = await Question.getQuestionOnly({ _id: this.questionID })
      this.fullObject = resp.data
      resp.data.document.ansData = false
      this.question = resp.data.document
      this.$forceUpdate()
      // this.question = QS.makeSampleQuestion()
    },
    async onMountedGo () {
      // Sound.absorb.play()
      require('../yoqb-compos/MyScript.vue').default.preload()

      // const hastagR = require('hashtag-regex')
      let easy = String(this.yoqb.game.question.easy).trim() //.match(hastagR())
      let medium = String(this.yoqb.game.question.medium).trim() //.match(hastagR())
      let hard = String(this.yoqb.game.question.hard).trim() //.match(hastagR())

      console.log('room, easy medium hard')
      console.log(this.yoqb.game.question, easy, medium, hard)

      console.log('current clicked brick')
      console.log(this.yoqb.cell)

      // console.log('this players')
      // console.log(this.players)
      // this.$emit('show', true)

      this.currentLevel = this.getCurrentLevel()

      let toUse = this.yoqb.game.question[this.currentLevel]
      console.log(toUse)

      let cell = this.yoqb.cell
      let myself = this.yoqb.myself
      let game = this.yoqb.game
      let players = this.yoqb.players

      let { mode } = sAPI.getDifficultyAndMode({ game, myself, cell, players })
      this.actionType = mode

      // if (cell.uid === 'map') {
      // } else if (cell.core) {
      //   this.actionType = 'captureCellCore'
      // } else if (cell.lvl >= 2) {
      //   this.actionType = 'captureOwnedCell'
      // } else if (cell.lvl >= 1) {
      //   this.actionType = 'captureOwnedCell'
      // } else if (cell.lvl >= 0) {
      //   this.actionType = 'captureOwnedCell'
      // }

      this.cellState = this.yoqb.cell
      this.tagOfQuestion = toUse
      let resp = await Folder.matchFolderTags({
        tags: toUse
      })
      let folders = resp.data
      console.log(folders)

      let randomFolder = folders[Math.floor(Math.random() * folders.length)]
      if (randomFolder) {
        let randomFolderID = randomFolder._id
        let questionResp = await Question.getRandomQuestion({ folderID: randomFolderID })

        this.questionObj = questionResp.data
        this.question = questionResp.data.document
        this.questionID = questionResp.data._id


        this.openDate = new Date()
      }
    },
    onAnswered (v) {
      this.showClose = true
      if (v) {
        if (v.mark > 0) {
          // this.$emit('right', v)
          this.onRightAns(v)
        } else {
          // this.$emit('wrong', v)
          this.onWrongAns(v)
        }
        // console.log(v.mark)
        this.$forceUpdate()
        this.$parent.$forceUpdate()
      }
    },
    collectResp ({ resp, correct }) {
      let now = new Date()
      let currentCell = JSON.parse(JSON.stringify(this.yoqb.cell))
      let game = this.yoqb.game
      let myself = this.yoqb.myself
      console.log(game)
      console.log(myself)

      let record = Analytics.collectResp({
        roomName: game.displayName,
        roomSize: `${game.width}x${game.height}`,
        displayName: myself.displayName,
        userID: myself.userID,
        gameID: game._id,
        resp: resp,
        question: this.questionObj.document,
        takeHowLongToAns: now.getTime() - this.openDate.getTime(),
        correct: correct,
        ansDate: now,
        full: resp.markFull,
        mark: resp.mark,
        userType: 'strapi',
        gameType: 'cell-game-cloud',
        questionBankFolderTagName: this.tagOfQuestion,
        questionBankFolderID: this.questionObj.folderID,
        questionBankQuestionID: this.questionObj._id,
        questionType: this.questionObj.document.ansType,
        levelOfQuestion: this.currentLevel,
        actionType: this.actionType,
        cellState: this.cellState,
        cellID: currentCell.numID
      })
      /*
      yo-analytics-post
      */

      setTimeout(() => {
        this.$refs.bordercolor.scrollTop = 1000000
      }, 10)
      setTimeout(() => {
        this.$refs.bordercolor.scrollTop = 1000000
      }, 20)
      setTimeout(() => {
        this.$refs.bordercolor.scrollTop = 1000000
      }, 30)
    },
    onRightAns (v) {
      Sound.correct.play()
      this.correct = true
      this.result = true
      this.collectResp({ resp: v, correct: true })

      this.ansIs = 'correct'
      this.yoqb.yes()
      // this.$emit('correct', this.correct)
      this.$forceUpdate()

      setTimeout(() => {
        this.$emit('show', false)
        this.$forceUpdate()
      }, 2000)
    },
    onWrongAns (v) {
      Sound.error.play()
      this.correct = false
      this.result = true
      this.collectResp({ resp: v, correct: false })

      this.ansIs = 'incorrect';
      this.$forceUpdate()
      // this.$emit('correct', this.correct)
      // console.log(this.$refs['answering'].$refs['bordercolor'].classList.add('isRed'))
    },
    async onSubmit(val) {
      let resp = await Question.getQuestion({ _id: this.questionID })
      this.fullObject = resp.data

      setTimeout(() => {
        this.question.ansData = resp.data.document.ansData
        this.$forceUpdate()
      }, 230)
    }
  }
}
</script>

<style scoped>
.full{
  height: 100%;
}
.question-row{
  display: flex;
  justify-content: center;
  margin: 20px 0px;
}
.content-box{
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  max-width: 600px;
  margin: 0px auto;
  padding: 0px 15px;
  background-color: rgba(255, 255, 255, 0.938);
  overflow: auto;
  min-height: calc(30vh);

  max-height: calc(100vh - 150px);

  border: #1B1464 solid 5px;
  border-radius: 30px;
  box-shadow: 0px 0px 30px 0px #f9f9f9;
  color: black;
  transform: translateY(30px);
}


.content-box.easy{
  border-color: #4EC604;
}
.content-box.medium{
  border-color: #ED9C03;
}
.content-box.hard{
  border-color: #FF0000;
}

.content-box.isRed{
  border-color: #FF0000;
}
.overlay{
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.9);
  z-index: 1000000;
}
.marginer{
  margin: 20px;
}


.close-btn{
  color: black;
  border-width: 3px;
  border-color: red;
  -webkit-box-shadow: 0px 0px 10px red;
  box-shadow: 0px 0px 10px red;
  background-color: rgba(255,255,255,0.5);
  margin: 10px;
  margin-left: 0px;
  border-radius: 30px;
  padding: 20px;
  font-size: 20px;
  color: red;
}

</style>
<style lang="css">
.ddel-button{
  display: inline-block;
	/* box-shadow:inset 0px 1px 0px 0px #ffffff; */
	background-color:transparent;
	border-radius:5px;
	display:inline-block;
	cursor:pointer;
	font-family:Arial;
	font-size:20px;
	font-weight:bold;
	padding:15px 24px;
	text-decoration:none;
	text-shadow:0px 1px 0px #ffffff;
}
.ddel-button{
  color: black;
  border-width: 3px;
  border-color: #39B54A;
  box-shadow: 0px 0px 10px #39B54A;
  background-color: rgba(255,255,255,0.5);
  margin: 10px;
  margin-left: 0px;
}
</style>